// extracted by mini-css-extract-plugin
var _1 = "card__MWqO7";
var _2 = "contentWrapper__kQ4wG";
var _3 = "imageWrapper__Ebhfa";
export { _1 as "card", _2 as "contentWrapper", _3 as "imageWrapper" }
export default { "card": _1, "contentWrapper": _2, "imageWrapper": _3 }
